import { makeStyles } from "tss-react/mui";

import { Box, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles()((theme: Theme) => {
    const isDark = theme.palette.mode === "dark";
    return {
        header: {
            display: "flex",
            alignItems: "flex-start",
            gap: theme.spacing(3),
            marginBottom: theme.spacing(5),
            flexShrink: 0,
        },
        headerWithoutDescription: {
            marginBottom: theme.spacing(5),
            flexShrink: 0,
        },
        textBlock: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
            justifyContent: "center",
            minHeight: 48,
        },
        title: {
            color: isDark ? theme.palette.emteria.text.primary : theme.palette.emteria.primary,
        },
        description: {
            color: theme.palette.text.primary,
        },
    };
});

type Props = {
    title: string;
    description?: React.ReactNode;
};

const PageHeader = (props: Props) => {
    const { classes } = useStyles();

    return (
        <Box className={classes.header}>
            <Box className={classes.textBlock}>
                <Typography variant="h6" fontWeight="bold" className={classes.title}>
                    {props.title}
                </Typography>
                {props.description ? (
                    <Typography variant="body1" className={classes.description}>
                        {props.description}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    );
};

export default PageHeader;
